var _style, _g, _g2, _g3, _g4, _g5, _g6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSavadogoLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 550,
    height: 110,
    viewBox: "0 0 550 110",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n    .text {\n        fill: none;\n        stroke: #ff00d4;\n        stroke-width: 5px;\n        stroke-linecap: square;\n        stroke-linejoin: miter;\n    }\n    .circle {\n        stroke: none;\n        fill: #8d1579;\n        transform: scale(0.6);\n    }\n    .line {\n        stroke: #fc94f7;\n        stroke-width: 20px;\n    }\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(50,50)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 -40 A 40 40 0 0 0 0 40 A 40 40 0 0 0 0 -40 Z",
    className: "circle"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 28.28 -28.28 A 40 40 0 0 0 -40.28 0 L 40 0 A 40 40 0 0 1 -28.28 28.28",
    className: "text"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(140,50)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 -40 A 40 40 0 0 0 0 40 A 40 40 0 0 0 0 -40 Z",
    className: "circle"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M -40 40 L -40 0 A 40 40 0 0 1 -5.01 -39.68 L -5.01 39.68 M -40 0 L -5.01 0",
    className: "text"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 5.01 -40 L 5.01 39.68 A 40 40 0 0 0 40 0 L 40 -40",
    className: "text"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(230,50)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 -40 A 40 40 0 0 0 0 40 A 40 40 0 0 0 0 -40 Z",
    className: "circle"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M -40 40 L -40 0 A 40 40 0 0 1 -5.01 -39.68 L -5.01 39.68 M -40 0 L -5.01 0",
    className: "text"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 5.01 0 L 5.01 39.68 A 40 40 0 0 0 5.01 -39.68 Z",
    className: "text"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(320,50)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 -40 A 40 40 0 0 0 0 40 A 40 40 0 0 0 0 -40 Z",
    className: "circle"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 0 -40 A 40 40 0 0 0 0 40 A 40 40 0 0 0 0 -40 Z",
    className: "text"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(410,50)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 -40 A 40 40 0 0 0 0 40 A 40 40 0 0 0 0 -40 Z",
    className: "circle"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 28.28 -28.28 A 40 40 0 1 0 40 0 L 0 0",
    className: "text"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(500,50)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 -40 A 40 40 0 0 0 0 40 A 40 40 0 0 0 0 -40 Z",
    className: "circle"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 0 -40 A 40 40 0 0 0 0 40 A 40 40 0 0 0 0 -40 Z",
    className: "text"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSavadogoLogo);
export default __webpack_public_path__ + "static/media/savadogo-logo.371d6b1441af55a2e7ce1f134eff2946.svg";
export { ForwardRef as ReactComponent };